<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-company|@@companyName">Compagnie</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <div class="container">
        <div [formGroup]="form">
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@name">Nom : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Nom" formControlName="name">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@address">Addresse : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Addresse" formControlName="address">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@phone">Tel : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Tel" formControlName="phone">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@mail">Mail : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Mail" formControlName="mail">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@website">Site : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="www.Site.com" formControlName="site">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@other">Autre : </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="Autre" formControlName="other">
            </div>
          </div>


          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@logo">Logo :
              </span>
            </div>
            <div class="col-5">
              <input type="button" id="get_logo" value="{{logoButton}}">
              <input type="file" name="my_logo" id="my_logo" accept="image/*"
                (change)="handleFileInputLogo($event.target.files)" />
            </div>
            <div class="col-2">
              <img *ngIf="settings.companyLogo && settings.companyLogo.url" src="{{settings.companyLogo.url()}}" alt=""
                id='imageLogo'>
            </div>
          </div>

          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@stamp">Tampon :
              </span>
            </div>
            <div class="col-5">
              <input type="button" id="get_stamp" value="{{stampButton}}">
              <input type="file" name="my_stamp" id="my_stamp" accept="image/*"
                (change)="handleFileInputStamp($event.target.files)" />
            </div>
            <div class="col-2">
              <img *ngIf="settings.companyStamp && settings.companyStamp.url" src="{{settings.companyStamp.url()}}" alt=""
                id='imageStamp'>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-company|@@footer">Bas de page (pdf rapport): </span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="texte de bas de page" formControlName="footer">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-company/parameters-company.component.html